module.exports = __webpack_public_path__ + "img/logo.71a6adea.png";